import { DEVICE_MODES } from "../../../../utils/constants/deviceConstants";

export const monthsList = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Aug",
  "Oct",
  "Nov",
  "Dec",
];
export const modeValue = {
  OPERATIONAL: "Operational",
  RESEARCH: "Research",
  SENSE_ONLY: "Sense Only",
  STANDBY: "StandBy",
  OFFLINE: "Offline",
  NEWLY_ONBOARDED: "No Data",
};
export const backgroundAnotation = {
  OPERATIONAL: {
    x: "",
    x2: "",
    fillColor: DEVICE_MODES.OPERATIONAL.color,
    opacity: 0.2,
    label: {
      orientation: "vertical",
      text: "Operational",
      cssClass: "statusNow",
      offsetX: 40,
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open sans",
      },
    },
  },
  RESEARCH: {
    x: "",
    x2: "",
    fillColor: DEVICE_MODES.RESEARCH.color,
    opacity: 0.2,
    label: {
      orientation: "vertical",
      text: "Research",
      cssClass: "statusNow",
      offsetX: 40,
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open sans",
      },
    },
  },
  SENSE_ONLY: {
    x: "",
    x2: "",
    fillColor: DEVICE_MODES.SENSE_ONLY.color,
    opacity: 0.2,
    label: {
      orientation: "vertical",
      text: "Sense Only",
      offsetX: 40,
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open sans",
      },
    },
  },
  STANDBY: {
    x: "",
    x2: "",
    fillColor: DEVICE_MODES.STANDBY.color,
    opacity: 0.2,
    label: {
      orientation: "vertical",
      text: "StandBy",
      offsetX: 40,
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open sans",
      },
    },
  },
  OFFLINE: {
    x: "",
    x2: "",
    fillColor: DEVICE_MODES.OFFLINE.color,
    opacity: 0.2,
    label: {
      orientation: "vertical",
      text: "Offline",
      opacity: 0,
      offsetX: 40,
      cssClass: "labelStyle",
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open sans",
      },
    },
  },
  NEWLY_ONBOARDED: {
    x: "",
    x2: "",
    fillColor: "#FFFFFF",
    opacity: 0.2,
    label: {
      orientation: "vertical",
      text: "No Data",
      opacity: 0,
      offsetX: 40,
      cssClass: "labelStyle",
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Open sans",
      },
    },
  },
};

export const chartSeries = [
  {
    name: "CIO2",
    type: "line",
    data: [],
  },
  {
    name: "HUMIDITY",
    type: "line",
    data: [],
  },
  {
    name: "SHOTSIZE",
    type: "scatter",
    data: [],
  },
  {
    name: "",
    type: "scatter",
    data: [],
    tooltip: {
      enabled: false,
    },
  },
];

export const chartOptions = {
  chart: {
    id: "device-chart",
    type: "line",
    stacked: false,
    zoom: {
      enabled: false,
    },
    animations: {
      enabled: false,
    },
  },
  tooltip: {
    enabled: true
  },
  // labels: [],
  xaxis: {
    type: "datetime",
    hideOverlappingLabels: true,
    tickAmount: 7,
    labels: {
      show: true,
      style: {
        colors: "#3C3C3C",
        fontSize: "13px",
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 600,
      },
      formatter: function (value, timestamp) {
        const date = new Date(timestamp);
        const optionsDate = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        };
        const optionsTime = {
          hour: "2-digit",
          minute: "2-digit",
        };

        const formattedDate = date.toLocaleDateString("en-US", optionsDate);
        const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

        return [formattedDate, formattedTime];
      },     
    }
  },
  yaxis: [
    {
      seriesName: "CIO2",
      tickAmount: 10,
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: "#3C3C3C",
      },
      labels: {
        style: {
          colors: "#3C3C3C",
          fontSize: "16px",
          fontFamily: '"Open Sans", sans-serif',
          fontWeight: 600,
        },
        formatter: function (value) {
          return Math.round(value);
        },
      },
      title: {
        text: "CIO2 PPB",
        style: {
          color: "#3C3C3C",
          fontSize: "16px",
        },
      },
    },
    {
      showForNullSeries: true,
      forceNiceScale: true,
      showAlways: true,
      opposite: true,
      seriesName: "HUMIDITY", // ShotSize config on Humidity y-Axis
      tickAmount: 10,
      labels: {
        style: {
          colors: "#3C3C3C",
          fontSize: "16px",
          fontFamily: '"Open Sans", sans-serif',
          fontWeight: 600,
        },
        formatter: function (value) {
          return Math.round(value);
        },
      },
      title: {
        text: "Humidity (%) & Shot Size (µL)",
        style: {
          color: "#3C3C3C",
          fontSize: "16px",
        },
      },
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: "#3C3C3C",
      },
      // markers: {
      //   size: [6, 6],
      // },
    },
    {
      forceNiceScale: true,
      showAlways: false,
      opposite: true,
      tickAmount: 10,
      seriesName: "HUMIDITY",
      show: false,
      labels: {
        style: {
          colors: "#3C3C3C",
          fontSize: "16px",
          fontFamily: '"Open Sans", sans-serif',
          fontWeight: 600,
        },
        formatter: function (value) {
          return value
        }, 
      },
    },
   
  ],
  toolbar: {
    show: false,
    offsetX: 0,
    offsetY: 0,
    tools: {
      download: true,
      selection: false,
      zoom: false,
      zoomin: false,
      zoomout: false,
      pan: false,
      reset: null,
      customIcons: [],
    },
    export: {
      csv: {
        filename: undefined,
        columnDelimiter: ",",
        headerCategory: "category",
        headerValue: "value",
        dateFormatter(timestamp) {
          return new Date(timestamp).toDateString();
        },
      },
      svg: {
        filename: undefined,
      },
      png: {
        filename: undefined,
      },
    },
    autoSelected: "zoom",
  },
  markers: {
    size: [0, 0, 5, 0],
  },
  colors: ["#3C3C3C", "#BB007B", "#fb5a4c", ""],
  stroke: {
    /**Line joining data points */
    width: [3, 3, 5, 0],
    curve: "straight",
  },
  legend: {
    show:false
    // To show the identifier for multiple series: https://apexcharts.com/docs/legend/
  },
  annotations: {
    xaxis: [],
  },
};
